<dv-chip
  class="vt-chip"
  #chip
  [removable]="true"
  [label]="label() || ''"
  [color]="color()"
  [strong]="false"
  (remove)="remove.emit()" />
